<template>
<v-app>
    <div class="login_page">

        <v-container>
            <v-row class="justify-center">
                <v-col cols="11" sm="10" md="11" lg="5" xl="6">
                    <v-card class="login">
                        <div class="logo">
                            <img src="@/assets/new_logologinandtkfull.png" alt="">
                        </div>
                        <form @submit.prevent="LogIn()">
                            <v-text-field v-model="tel" type="tel" maxlength="10" @keypress="isNumber($event)" onpaste="return false" label="เบอร์โทร" outlined required>
                            </v-text-field>
                            <v-text-field v-model="password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" name="input-10-1" label="รหัสผ่าน" @click:append="show = !show" outlined required>
                            </v-text-field>
                            <button type="submit" class="login_success">
                                เข้าสู่ระบบ
                            </button>
                        </form>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="alert_error" persistent max-width="600">
            <v-card>
                <v-card-title class="error_text_login">
                    คำเตือน !
                </v-card-title>

                <v-card-text>
                    เบอร์โทรและรหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="confirmError()">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'login',
    data() {
        return {
            show: false,
            tel: '',
            password: '',
            alert_error: false,

        }
    },
    methods: {
        async checkLogin() {
            if (this.$store.state.token !== null) {
                // this.$router.push('/')
                this.$router.push('/poslist')
            }
        },
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async LogIn() {
            let data = {
                tel: this.tel,
                password: this.password
            }
            try {
                const response = await HTTP.post('/auth/login', data)
                if (response.data.successful === true) {
                    const userData = {
                        token: response.data.token,
                    }
                    this.$store.commit('logInSuccess', userData)
                    this.checkLogin()
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.alert_error = true
                }
            }
        },
        async confirmError() {
            this.alert_error = false
            this.tel = ''
            this.password = ''
        }
    },
    mounted() {
        this.checkLogin()
    }
}
</script>

<style scoped>
.login_page {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('~@/assets/vuexy-login-bg.jpg');
    background-size: cover;
}

.login {
    padding: 30px;
}

.logo {
    width: 100px;
    margin: auto;
}

.logo>img {
    max-width: 100%;
}

.login_success {
    /*border-color: #28ab28 !important;*/
    /*background-color: #28ab28 !important;*/
    background: linear-gradient(to top, #038cc1, #55c0e9) !important;
    color: #fff;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    border: 0 solid transparent;
    padding: 0.9rem 2rem;
    font-size: 1rem;
    line-height: 1;
    border-radius: 0.4285rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    width: 100%;
}

.login_success:focus {
    outline: none;
}

.login_success:hover {
    background: linear-gradient(to top, #038cc1, #55c0e9) !important;
    color: #fff !important;
    box-shadow: 0 8px 25px -8px #038cc1;
}

.error_text_login {
    color: #ff5252;
}
</style>
